// assets/customer-info.js — FINAL WORKING
document.addEventListener('DOMContentLoaded', function () {
  const id = parseInt(window.location.pathname.split('/').pop(), 10);
//   const FILE_URL = 'https://cdn.shopify.com/s/files/1/0943/5791/3943/files/customers.json';
const FILE_URL = 'https://script.google.com/macros/s/AKfycby4omc7ILOdXf9uLF8Ivd2Mf-2cmcYZmNrDQ_rXDnbvhzM2o8JSxDvtdq9lWcnGInXy/exec';
  console.log('Customer Info JS Running');
  console.log('ID:', id);
  console.log('Fetching:', FILE_URL);

  if (isNaN(id)) {
    document.getElementById('customer-data').innerHTML = '<p>Invalid ID</p>';
    return;
  }

  fetch(FILE_URL + '?t=' + Date.now())
    .then(r => {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(data => {
      console.log('JSON loaded:', data);
      const user = data.find(u => Number(u.customerid) === id);
      const el = document.getElementById('customer-data');

      if (user) {
        el.innerHTML = `
          <div class="plate">${user.company}</div>
          <div class="info"><strong>Name:</strong> ${user.name}</div>
          <div class="info"><strong>Email:</strong> ${user.email}</div>
          <div class="bookings">
            ${user.bookings.length 
  ? '<ul style="list-style:none; padding:0; margin:15px 0;">' + 
    user.bookings.map(b => 
      `<li style="margin-bottom:12px; padding:10px; background:#f8f9fa; border-radius:10px;">
         <div style="font-weight:700; font-size:1.2em; color:#d32f2f;">${b.event || 'Parking'}</div>
         <div style="color:#555; font-size:0.9em;">Order:: ${b.order}</div>
       </li>`
    ).join('') + '</ul>'
  : '<p><em></em></p>'
}
          </div>
        `;
      } else {
        el.innerHTML = `<p class="not-found">Customer #${id} not found.</p>`;
      }
    })
    .catch(err => {
      console.error('Fetch failed:', err);
      document.getElementById('customer-data').innerHTML = 
        '<p class="not-found">Error: ' + err.message + '</p>';
    });
});